import { Option, some, none, fold } from "fp-ts/lib/Option";
import { pipe } from "fp-ts/lib/pipeable";
import { flexguardCalculatorUrlForRef, flexguardExportUrlForRef, productCusipCodeForShareClass } from '../shared/serviceUrl';

interface CalculatorURLConfigRule {
    applicationName: string;
    shareClass: string;
    serviceRef: string;
}



export class CalculatorURLConfig {

    private readonly shareClassesByApplicationName: Map<string, Map<string, string>>;

    constructor(ruleConfigs: Array<CalculatorURLConfigRule>) {
        this.shareClassesByApplicationName = new Map<string, Map<string, string>>();
        for (const cfg of ruleConfigs) {
            const appName = cfg.applicationName ? cfg.applicationName.trim() : '';
            const shareClass = cfg.shareClass ? cfg.shareClass.trim() : '';
            const serviceRef = cfg.serviceRef ? cfg.serviceRef.trim() : '';
            if (appName && shareClass && serviceRef) {
                if (this.shareClassesByApplicationName.has(appName)) {
                    const shareClassMap = this.shareClassesByApplicationName.get(appName);
                    if (shareClassMap) {
                        shareClassMap.set(shareClass, serviceRef);
                    }
                } else {
                    const appName = cfg.applicationName.trim();
                    if (appName) {
                        const shareClassMap = new Map<string, string>();
                        shareClassMap.set(shareClass, serviceRef);
                        this.shareClassesByApplicationName.set(appName, shareClassMap);
                    }
                }
            }
        }
    }

    serviceRefForConfig(appName: string, shareClass: string): Option<string> {
        if (this.shareClassesByApplicationName.has(appName.trim())) {
            const shareClassMap = this.shareClassesByApplicationName.get(appName.trim());
            if (shareClassMap && shareClassMap.has(shareClass.trim())) {
                const serviceRef = shareClassMap.get(shareClass.trim());
                if (serviceRef) {                    
                    return some(serviceRef);
                } else {                    
                    return none;
                }
            } else {
                return none;
            }
        } else {
            return none;
        }
    }


    urlForConfig(appName: string, shareClass: string): Option<string> {
        return pipe(this.serviceRefForConfig(appName, shareClass),
            fold(() => {
                console.error(`ERROR: No Calculator API config found for params {applicationName: '${appName}', shareClass: '${shareClass}'}`);
                return none;
            },
                (serviceRef) => flexguardCalculatorUrlForRef(serviceRef)
            ));
    }

    exportUrlForConfig(appName: string, shareClass: string): Option<string> {
        return pipe(this.serviceRefForConfig(appName, shareClass),
            fold(() => {
                console.error(`ERROR: No Calculator API config found for params {applicationName: '${appName}', shareClass: '${shareClass}'}`);
                return none;
            },
                (serviceRef) => flexguardExportUrlForRef(serviceRef)
            ));
    }

    productCusipForConfig(shareClass: string): Option<string> {
        return productCusipCodeForShareClass(shareClass);
    }
}